exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:1400px){.wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step{width:calc(25% - .5rem)!important;flex:0 0 calc(25% - 0.5rem)}}", ""]);

// exports
